<template>
    <div class="loginCotain">
        <el-dialog
            :visible.sync="show"
            :showClose="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false">
            <!-- 登录 -->
            <div v-if="currentFunction === 'login'" class="Content">
                <i
                    class="el-icon-circle-close icon font-size36 c-fff"
                    @click="closeDiolog"
                ></i>
                <div class="loginText jf">
                    <div class="images"></div>
                    <div class="form">
                        <div class="navTit xy-between">
                            <div
                                v-if="$store.getters.availablePlatform([HOME_PAGE_MAP.yixue.hostKey, HOME_PAGE_MAP.jigou.hostKey, HOME_PAGE_MAP.default.hostKey])"
                                class="font-size16 tab yx-between cursor"
                                @click="personLogin">
                                <div>个人账号</div>
                                <div
                                    v-if="currentStatus === 'person'"
                                    class="line"
                                ></div>
                            </div>
                            <div
                                class="font-size16 tab yx-between perLogin cursor"
                                @click="schoolAccount">
                                <div>机构学员</div>
                                <div
                                    v-if="currentStatus === 'school'"
                                    class="line"
                                ></div>
                            </div>
                            <div
                                class="font-size16 tab yx-between perLogin cursor"
                                @click="manageLogin"
                            >
                                <div>机构管理员</div>
                                <div
                                    v-if="currentStatus === 'manage'"
                                    class="line"
                                ></div>
                            </div>
                        </div>
                        <div>
                            <!-- 机构登录 -->
                            <div
                                v-if="currentStatus === 'school'"
                                class="formMaps schoolLogin"
                            >
                                <el-input
                                    placeholder="请输入机构账号"
                                    prefix-icon="el-icon-user"
                                    v-model="account"
                                >
                                </el-input>
                                <form>
                                    <el-input
                                        type="passWord"
                                        placeholder="请输入密码"
                                        prefix-icon="el-icon-lock"
                                        v-model="passWord"
                                    >
                                    </el-input>
                                </form>
                                <el-select
                                    class="selectSchool"
                                    v-model="selectSchool"
                                    slot="prepend"
                                    filterable
                                    remote
                                    clearable
                                    reserve-keyword
                                    :remote-method="GetOrganInfo"
                                    @keyup.enter.native="schoolLoginBtn()"
                                    placeholder="请输入关键字检索机构..."
                                >
                                    <el-option
                                        v-for="(item, i) in schoolList"
                                        :key="i"
                                        :label="item.Name"
                                        :value="item.ID"
                                    ></el-option>
                                </el-select>
                                <div class="forgetPassWord xy-between">
                                    <div class="cursor" @click="loginByPhone">
                                        验证码登录
                                    </div>
                                    <div class="cursor" @click="forGetPassWord">
                                        忘记密码？
                                    </div>
                                </div>
                                <div class="AgreementBox"></div>
                                <div
                                    class="loginbtn xy-center cursor"
                                    v-loading="loading"
                                    @click="schoolLoginBtn"
                                >
                                    登录
                                </div>
                                <div
                                    class="registered cursor"
                                    @click="personGoregeter">
                                    立即注册
                                </div>
                            </div>

                            <!-- 个人登录 -->
                            <div
                                v-else-if="currentStatus === 'person'"
                                class="formMaps personLogin"
                            >
                                <el-input
                                    placeholder="请输入个人账号"
                                    prefix-icon="el-icon-user"
                                    v-model="personAccount"
                                >
                                </el-input>
                                <!-- <form> -->
                                <el-input
                                    class="personLofinPass"
                                    placeholder="请输入密码"
                                    prefix-icon="el-icon-lock"
                                    v-model="personPassWord"
                                    show-password
                                    @keyup.enter.native="personLoginBtn()"
                                >
                                </el-input>
                                <!-- </form> -->
                                <div class="forgetPassWord xy-between">
                                    <div class="cursor" @click="loginByPhone">
                                        验证码登录
                                    </div>
                                    <div class="cursor" @click="forGetPassWord">
                                        忘记密码？
                                    </div>
                                </div>
                                <div class="AgreementBox"></div>
                                <div
                                    class="loginbtn xy-center cursor"
                                    v-loading="loading"
                                    @click="personLoginBtn"
                                >
                                    登录
                                </div>
                                <div
                                    class="registered cursor"
                                    @click="personGoregeter"
                                >
                                    立即注册
                                </div>
                            </div>
                            <!-- 个人登录 -->

                            <!--管理员账号-->
                            <div
                                v-else-if="currentStatus === 'manage'"
                                class="formMaps personLogin"
                            >
                                <el-input
                                    placeholder="请输入管理员账号"
                                    prefix-icon="el-icon-user"
                                    v-model="manageAccount"
                                >
                                </el-input>
                                <!-- <form> -->
                                <el-input
                                    class="personLofinPass"
                                    placeholder="请输入密码"
                                    prefix-icon="el-icon-lock"
                                    v-model="managePwd"
                                    show-password
                                    @keyup.enter.native="manageLoginBtn()"
                                >
                                </el-input>
                                <!-- </form> -->
                                <div class="forgetPassWord xy-between ">
                                    <div class="cursor" @click="loginByPhone">
                                        验证码登录
                                    </div>
                                    <div class="cursor" @click="forGetPassWord">
                                        忘记密码？
                                    </div>
                                </div>
                                <div class="AgreementBox"></div>
                                <div
                                    class="loginbtn xy-center cursor"
                                    @click="manageLoginBtn"
                                    v-loading="loading"
                                >
                                    登录
                                </div>
                                <!-- <div class="registered cursor" @click="personGoregeter">
                                    立即注册
                                </div> -->
                            </div>
                            <!--管理员账号-->
                        </div>
                    </div>
                </div>
            </div>
            <!-- 登录 -->

            <!-- 注册 -->
            <div v-else-if="currentFunction === 'regeter'" class="Content ">
                <i
                    class="el-icon-circle-close icon font-size36 c-fff"
                    @click="closeDiolog"
                ></i>
                <div class="registerText ">
                    <div class="titText  xy-center">
                        <div
                            class="back c-2C2F35 jf font-size14 cursor"
                            @click="regeteBack('regter')"
                        >
                            <i class="el-icon-arrow-left"></i>
                            返回
                        </div>
                        <div class="c-2C2F35 font-size16">注册</div>
                    </div>
                    <div class="forms xy-center">
                        <ul class="contain ">
                            <li class="jf containItem">
                                <div class="label">
                                    用户名
                                </div>
                                <div class="rightInput">
                                    <el-input
                                        placeholder="请使用手机号为用户名"
                                        v-model="regeterUserName"
                                    >
                                    </el-input>
                                </div>
                            </li>

                            <li class="jf containItem">
                                <div class="label">
                                    真实姓名
                                </div>
                                <div class="rightInput">
                                    <el-input
                                        placeholder="请输入真实姓名"
                                        v-model="realName"
                                    >
                                    </el-input>
                                </div>
                            </li>

                            <li class="jf containItem">
                                <div class="label">
                                    电话号码
                                </div>
                                <div class="rightInput">
                                    <el-input
                                        placeholder="请输入电话号码"
                                        v-model="phone"
                                    >
                                    </el-input>
                                </div>
                            </li>

                            <li class="jf containItem">
                                <div class="label">
                                    验证码
                                </div>
                                <div class="rightInput jf">
                                    <el-input
                                        placeholder="验证码"
                                        v-model="yzm"
                                    >
                                    </el-input>
                                    <div>
                                        <div
                                            v-if="!isShowCountdown"
                                            class="yzmBtn xy-center"
                                            @click="sendValiteCode">
                                            获取验证码
                                        </div>
                                        <div v-else class="jsq xy-center">
                                            {{ countdown }}秒后重发
                                        </div>
                                    </div>
                                </div>
                            </li>

                            <li class="jf containItem">
                                <div class="label">
                                    密码
                                </div>
                                <div class="rightInput">
                                    <el-input
                                        placeholder="请输入密码"
                                        v-model="regesterPassword"
                                        show-password
                                    >
                                    </el-input>
                                </div>
                            </li>

                            <li class="jf containItem">
                                <div class="label">
                                    确认密码
                                </div>
                                <div class="rightInput">
                                    <el-input
                                        placeholder="请再次输入密码"
                                        v-model="regesterPasswordTwo"
                                        show-password
                                    >
                                    </el-input>
                                </div>
                            </li>
                            <li class="containItem jf  ">
                                <div class="label"></div>
                                <div class="rightInput">
                                    <el-checkbox
                                        v-model="isReadAgreent"
                                    ></el-checkbox>
                                    已阅读<span
                                        class="c-0C95FD"
                                        @click="gotoUserAgreement"
                                        >《用户协议》</span
                                    >及
                                    <span
                                        @click="goToPrivacyAgreement"
                                        class="c-0C95FD"
                                        >《隐私协议》</span
                                    >
                                </div>
                            </li>
                            <li class="containItem xy-center ">
                                <div class="label"></div>
                                <div
                                    class="rightInput regeterBtn  font-size16 xy-center"
                                    v-loading="loading"
                                    @click="regeterUser"
                                >
                                    注册
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- 注册 -->

            <!-- 修改密码 -->
            <div
                v-if="currentFunction === 'editorPass'"
                class="Content editorForm"
            >
                <i
                    class="el-icon-circle-close icon font-size36 c-fff"
                    @click="closeDiolog"
                ></i>
                <div class="loginText jf">
                    <div class="images"></div>
                    <div class="form">
                        <div class="navTit xy-center">
                            <div
                                class="backIcon cursor"
                                @click="regeteBack('editor')"
                            >
                                <i class="el-icon-arrow-left"></i>
                                返回
                            </div>
                            <div class="font-size16  ">修改密码</div>
                        </div>

                        <div>
                            <div class="formMaps ">
                                <el-input
                                    placeholder="请输入手机号"
                                    v-model="editorPhone"
                                >
                                </el-input>
                                <div class="yzmInput ">
                                    <el-input
                                        placeholder="请输入验证码"
                                        v-model="editorYzm"
                                    >
                                    </el-input>
                                    <div class=" cursor">
                                        <div
                                            v-if="!editorIsSendCode"
                                            class="yzmBtn xy-center"
                                            @click="editorGetCode"
                                        >
                                            获取验证码
                                        </div>
                                        <div v-else class="cutDown xy-center">
                                            {{ editorCuttDownTime }}秒后重发
                                        </div>
                                    </div>
                                </div>
                                <form>
                                    <el-input
                                        placeholder="请输入新密码"
                                        v-model="editorNewPassWordOne"
                                        show-password
                                    >
                                    </el-input>
                                </form>
                                <form>
                                    <el-input
                                        class="secondInputWord"
                                        placeholder="请再次输入新密码"
                                        v-model="editorNewPassWord"
                                        show-password
                                    >
                                    </el-input>
                                </form>
                                <div class="forgetPassWord xy-between "></div>
                                <div
                                    class="loginbtn xy-center cursor"
                                    @click="resetPassWord"
                                >
                                    重置密码
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 修改密码 -->

            <!-- 验证码登录 -->
            <div
                v-if="currentFunction === 'loginByCode'"
                class="Content editorForm  loginByCode"
            >
                <i
                    class="el-icon-circle-close icon font-size36 c-fff"
                    @click="closeDiolog"
                ></i>
                <div class="loginText jf">
                    <div class="images"></div>
                    <div class="form">
                        <div class="navTit xy-center">
                            <div
                                class="backIcon cursor"
                                @click="regeteBack('yzm')"
                            >
                                <i class="el-icon-arrow-left"></i>
                                返回
                            </div>
                            <div class="font-size16  ">验证码登录</div>
                        </div>

                        <div>
                            <div class="formMaps ">
                                <el-input
                                    placeholder="请输入手机号"
                                    v-model="loginByPhoneNumber"
                                >
                                </el-input>
                                <div class="yzmInput ">
                                    <el-input
                                        placeholder="请输入验证码"
                                        v-model="loginByPhoneYzm">
                                    </el-input>
                                    <div class=" cursor">
                                        <div
                                            v-if="!loginByPhoneIsSendCode"
                                            class="yzmBtn xy-center"
                                            @click="loginByPhoneGetCode"
                                        >
                                            获取验证码
                                        </div>
                                        <div v-else class="cutDown xy-center">
                                            {{
                                                loginByPhoneCuttDownTime
                                            }}秒后重发
                                        </div>
                                    </div>
                                </div>
                                <div class="AgreementBox">
                                    <el-checkbox
                                        class=""
                                        v-model="yzmLoginAgreement"
                                    >
                                        我已阅读<span
                                            class="c-0C95FD"
                                            @click="gotoUserAgreement"
                                            >《用户协议》</span
                                        >及
                                        <span
                                            @click="goToPrivacyAgreement"
                                            class="c-0C95FD"
                                            >《隐私协议》</span
                                        >
                                    </el-checkbox>
                                </div>
                                <div
                                    class="loginbtn xy-center cursor"
                                    v-loading="loading"
                                    @click="loginBtnByPhone"
                                >
                                    登录
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 验证码登录 -->
        </el-dialog>
    </div>
</template>

<script>
import { GetOrganInfoByKeyword, GetOrganLevelInfo } from "@/api/organ";
import { HOME_PAGE_MAP } from "@/utils/platform-config";
import {
    accountLogin,
    UserInfo,
    Register,
    SendUpdatePassCode,
    TelLogin,
    ForgetPassForTeL,
    SendRegCode,
    SendLoginCode,
    ManageLogin,
    AdminUserInfo
} from "@/api/user";
import config from "@/config";
import { PmStateMixin } from "@/mixins/reqState";
import { sm2Encrypt } from "@/utils/sm2"
export default {
    name: "LoginDiolog",
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    components: {},
    mixins: [PmStateMixin],
    data(vm) {
        const currentStatus = vm.$store.getters.availablePlatform([HOME_PAGE_MAP.jigou.hostKey, HOME_PAGE_MAP.yixue.hostKey]) ? "person" : "school"
        return {
            currentStatus,
            currentFunction: "login",
            account: "",
            passWord: "",
            schoolName: "",
            personAccount: "",
            personPassWord: "",
            isReadAgreent: false,
            regeterUserName: "",
            realName: "",
            phone: "",
            yzm: "",
            regesterPassword: "",
            regesterPasswordTwo: "",
            countdown: 60,
            isShowCountdown: false,
            timer: "",
            selectSchool: "",
            schoolList: [],
            editorPhone: "",
            editorYzm: "",
            editorNewPassWordOne: "",
            editorNewPassWord: "",
            editorCuttDownTime: 60,
            editorIsSendCode: false,
            editorCutdownTimer: "",
            loginByPhoneNumber: "",
            loginByPhoneYzm: "",
            loginByPhoneIsSendCode: false,
            yzmLoginAgreement: false,
            loginByPhoneCuttDownTime: 60,
            loginByPhoneTimer: "",
            organName: "",
            // 管理员账号
            manageAccount: "",
            // 管理员密码
            managePwd: "",
            loading: false,
            HOME_PAGE_MAP
        };
    },
    computed: {},
    watch: {
        show(val) {
            if (!this.show) {
                // 关闭之后再进来默认是个人登录
                this.currentFunction = "login";

                this.account = "";
                this.passWord = "";
                this.selectSchool = "";

                this.personAccount = "";
                this.personPassWord = "";

                this.regeterUserName = "";
                this.realName = "";
                this.phone = "";
                this.yzm = "";
                this.regesterPassword = "";
                this.regesterPasswordTwo = "";
                this.isReadAgreent = false;

                this.editorPhone = "";
                this.editorYzm = "";
                this.editorNewPassWordOne = "";
                this.editorNewPassWord = "";

                this.loginByPhoneNumber = "";
                this.loginByPhoneYzm = "";
            }
        }
    },
    created() {},
    beforeDestroy() {},
    methods: {
        // 根据关键字获取机构信息
        async GetOrganInfo(organName) {
            const { data } = await GetOrganInfoByKeyword({
                pageSize: 15,
                sortBy: "CreateTime",
                sortOrder: "desc",
                keyWord: organName
            });
            if (data.code === 100) {
                this.schoolList = data.data;
            }
        },
        async GetOrganLevelInfo(value) {
            try {
                if (value) {
                    let organObj = {};
                    organObj = this.organData.find((item) => {
                        if (item.ID === value) {
                            this.organName = item.Name;
                        }
                    });
                    this.organId = value;
                    const { data } = await GetOrganLevelInfo({
                        organId: value
                    });
                    if (data.code === 100) {
                        this.organLeverData = data.data;
                    }
                }
            } catch (err) {}
        },
        loginByPhoneGetCode() {
            if (!this.loginByPhoneNumber) {
                return this.$message({
                    type: "warning",
                    message: `请输入手机号`
                });
            }
            if (!this.check_mobil(this.loginByPhoneNumber)) {
                return this.$message({
                    type: "warning",
                    message: `请输入正确的手机号`
                });
            }
            this.SendLoginCode();
        },
        // 验证码登录按钮
        loginBtnByPhone() {
            if (!this.loginByPhoneNumber) {
                return this.$message({
                    type: "warning",
                    message: `请输入手机号`
                });
            }
            if (!this.check_mobil(this.loginByPhoneNumber)) {
                return this.$message({
                    type: "warning",
                    message: `请输入正确的手机号`
                });
            }
            if (!this.loginByPhoneYzm) {
                return this.$message({
                    type: "warning",
                    message: `请输入验证码`
                });
            }
            if (!this.yzmLoginAgreement) {
                return this.$message({
                    type: "warning",
                    message: `请阅读相关协议`
                });
            }
            this.TelLogin();
        },
        async TelLogin() {
            try {
                const { data } = await this.wrapPromising(TelLogin({
                    tel: this.loginByPhoneNumber,
                    sendcode: this.loginByPhoneYzm,
                    PlatformName: HOME_PAGE_MAP[this.$store.state.platform].domain,
                    currentStatus: this.currentStatus
                }), "loading");
                if (data.code === -1) {
                    return this.$message({
                        type: "warning",
                        message: `${data.msg}`
                    });
                }
                this.$store.commit("setUser", data.data);
                this.$message({
                    type: "success",
                    message: `登录成功`
                });
                if (this.currentStatus === "manage") {
                    await this.adminInfo()
                } else {
                    await this.UserInfo();
                }
                this.closeDiolog();
            } catch (error) {
                console.log(error);
            }
        },
        // 发送登录验证码
        async SendLoginCode() {
            try {
                const { data } = await SendLoginCode({
                    tel: this.loginByPhoneNumber,
                    currentStatus: this.currentStatus
                });
                this.loginByPhoneIsSendCode = true;
                this.loginByPhoneTimer = setInterval(() => {
                    this.loginByPhoneCuttDownTime--;
                    if (this.loginByPhoneCuttDownTime === 0) {
                        clearInterval(this.loginByPhoneTimer);
                        this.loginByPhoneIsSendCode = false;
                        this.loginByPhoneCuttDownTime = 60;
                    }
                }, 1000);
            } catch (error) {
                console.log(error);
            }
        },
        // 验证码登录
        loginByPhone() {
            this.currentFunction = "loginByCode";
        },
        editorGetCode() {
            if (!this.editorPhone) {
                return this.$message({
                    type: "warning",
                    message: `请输入手机号`
                });
            }
            if (!this.check_mobil(this.editorPhone)) {
                return this.$message({
                    type: "warning",
                    message: `请输入正确的手机号`
                });
            }
            this.SendUpdatePassCode();
        },
        async SendUpdatePassCode() {
            try {
                const { data } = await SendUpdatePassCode({
                    tel: this.editorPhone
                });
                this.editorIsSendCode = true;
                this.editorCutdownTimer = setInterval(() => {
                    this.editorCuttDownTime--;
                    if (this.editorCuttDownTime === 0) {
                        clearInterval(this.editorCutdownTimer);
                        this.editorIsSendCode = false;
                        this.editorCuttDownTime = 60;
                    }
                }, 1000);
            } catch (err) {
                console.log(err);
            }
        },
        check_mobil(phone) {
            if (!/^1[3456789]\d{9}$/.test(phone)) {
                return false;
            } else {
                return true;
            }
        },
        async resetPassWord() {
            if (!this.editorPhone) {
                return this.$message({
                    type: "warning",
                    message: `手机号`
                });
            }
            if (!this.editorYzm) {
                return this.$message({
                    type: "warning",
                    message: `请输入验证码`
                });
            }
            if (!this.editorNewPassWordOne) {
                return this.$message({
                    type: "warning",
                    message: `请输入密码`
                });
            }
            if (typeof this.editorNewPassWordOne === "string" && (this.editorNewPassWordOne.length < 6 || this.editorNewPassWordOne.length > 18)) {
                return this.$message.warning("密码长度在6~18位之间")
                // return this.$message.warning("请确认账号、密码或机构输入是否正确")
            }
            if (
                !/(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]/.test(
                    this.editorNewPassWordOne
                )
            ) {
                return this.$message({
                    type: "warning",
                    message: `密码包含数字、大小写字母、特殊字符至少两种`
                });
            }
            if (!this.editorNewPassWord) {
                return this.$message({
                    type: "warning",
                    message: `请再次输入密码`
                });
            }
            if (this.editorNewPassWordOne !== this.editorNewPassWord) {
                return this.$message({
                    type: "warning",
                    message: `两次输入的密码不同`
                });
            }
            this.ForgetPassForTeL();
        },
        async ForgetPassForTeL() {
            try {
                const { data } = await this.wrapPromising(ForgetPassForTeL({
                    tel: this.editorPhone,
                    sendcode: this.editorYzm,
                    newpass: sm2Encrypt(this.editorNewPassWord)
                }, this.currentStatus), "loading");
                if (data.code === -1) {
                    return this.$message({
                        type: "warning",
                        message: `${data.msg}`
                    });
                }
                this.$message({
                    type: "success",
                    message: `修改成功`
                });
                this.regeteBack("editor");
            } catch (err) {
                console.log(err);
            }
        },
        regeteBack(val) {
            this.currentFunction = "login";
            if (val === "yzm") {
                this.loginByPhoneIsSendCode = false;
                clearInterval(this.loginByPhoneTimer);
                this.loginByPhoneCuttDownTime = 60;
                this.loginByPhoneNumber = "";
                this.loginByPhoneYzm = "";
            } else if (val === "editor") {
                this.editorIsSendCode = false;
                clearInterval(this.editorCutdownTimer);
                this.editorCuttDownTime = 60;
                this.editorPhone = "";
                this.editorYzm = "";
                this.editorNewPassWordOne = "";
                this.editorNewPassWord = "";
            } else if (val === "regter") {
                this.isShowCountdown = false;
                this.countdown = 60;
                clearInterval(this.timer);
                this.regeterUserName = "";
                this.realName = "";
                this.phone = "";
                this.yzm = "";
                this.regesterPassword = "";
                this.regesterPasswordTwo = "";
                this.isReadAgreent = false;
            }
        },
        regeterUser() {
            if (!this.regeterUserName) {
                return this.$message({
                    type: "warning",
                    message: `请输入用户名`
                });
            }
            if (!this.realName) {
                return this.$message({
                    type: "warning",
                    message: `请输入真实姓名`
                });
            }
            if (!this.phone) {
                return this.$message({
                    type: "warning",
                    message: `请输入手机号`
                });
            }
            if (!this.regesterPassword) {
                return this.$message({
                    type: "warning",
                    message: `请输入密码`
                });
            }
            if (typeof this.regesterPassword === "string" && (this.regesterPassword.length < 6 || this.regesterPassword.length > 18)) {
                return this.$message.error("密码长度在6~18位之间")
                // return this.$message.error("请确认账号、密码或机构输入是否正确")
            }
            if (
                !/(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]/.test(
                    this.regesterPassword
                )
            ) {
                return this.$message({
                    type: "warning",
                    message: `密码包含数字、大小写字母、特殊字符至少两种`
                });
            }
            if (!this.regesterPasswordTwo) {
                return this.$message({
                    type: "warning",
                    message: `请再次输入密码`
                });
            } else if (this.regesterPasswordTwo !== this.regesterPassword) {
                return this.$message({
                    type: "warning",
                    message: `两次输入的密码不一致`
                });
            }

            if (!this.yzm) {
                return this.$message({
                    type: "warning",
                    message: `请输入验证码`
                });
            }

            if (!this.isReadAgreent) {
                return this.$message({
                    type: "warning",
                    message: `请阅读相关协议`
                });
            }
            this.Register();
        },
        async Register() {
            try {
                const { data } = await this.wrapPromising(
                    Register({
                        userName: this.regeterUserName,
                        passWord: sm2Encrypt(this.regesterPasswordTwo),
                        realName: this.realName,
                        tel: this.phone,
                        sendcode: this.yzm
                    }),
                    "loading"
                );
                if (data.code === -1) {
                    return this.$message({
                        type: "warning",
                        message: `${data.msg}`
                    });
                }
                if (data.code === 100) {
                    this.$message({
                        type: "success",
                        message: data.msg || "注册成功"
                    });
                }
                this.regeteBack("regter");
            } catch (error) {
                console.log(error);
            }
        },
        async sendValiteCode() {
            if (!this.phone) {
                return this.$message({
                    type: "warning",
                    message: `请输入手机号`
                });
            }
            if (!this.check_mobil(this.phone)) {
                return this.$message({
                    type: "warning",
                    message: `请输入正确的手机号`
                });
            }
            try {
                const { data } = await SendRegCode({
                    tel: this.phone
                });
                if (data.code === -1) {
                    return this.$message({
                        type: "error",
                        message: `${data.msg}`
                    });
                }
                this.isShowCountdown = true;
                this.timer = setInterval(() => {
                    this.countdown--;
                    if (this.countdown === 0) {
                        clearInterval(this.timer);
                        this.isShowCountdown = false;
                        this.countdown = 60;
                    }
                }, 1000);
            } catch (err) {
                console.log("err", err);
                // 发送失败，关闭倒计时
                this.isCountDownShow = false;
                if (err.response.status === 429) {
                    this.$message("发送太频繁了，请稍后重试");
                } else {
                    this.$message("发送失败，请稍后重试");
                }
            }
        },
        open() {
            this.dialogVisible = true;
        },
        forGetPassWord() {
            this.currentFunction = "editorPass";
        },
        closeDiolog() {
            this.$emit("update:show", false);
        },
        schoolAccount() {
            this.currentStatus = "school";
            this.personAccount = "";
            this.personPassWord = "";
        },
        personLogin() {
            this.currentStatus = "person";
            this.account = "";
            this.passWord = "";
            this.selectSchool = "";
        },
        // 机构管理员登录
        manageLogin() {
            this.currentStatus = "manage";
        },
        schoolLoginBtn() {
            if (!this.account) {
                return this.$message({
                    type: "warning",
                    message: `请输入用户账号`
                });
            }
            if (!this.passWord) {
                return this.$message({
                    type: "warning",
                    message: `请输入密码`
                });
            }
            if (!this.selectSchool) {
                return this.$message({
                    type: "warning",
                    message: `请选择机构`
                });
            }
            this.accountLogin();
        },
        personGoregeter() {
            this.currentFunction = "regeter";
        },
        personLoginBtn() {
            if (!this.personAccount) {
                return this.$message({
                    type: "warning",
                    message: `请输入用户账号`
                });
            }
            if (!this.personPassWord) {
                return this.$message({
                    type: "warning",
                    message: `请输入密码`
                });
            }
            if (typeof this.personPassWord === "string" && (this.personPassWord.length < 6 || this.personPassWord.length > 18)) {
                // return this.$message.error("密码长度在6~18位之间")
                return this.$message.error("请确认账号、密码输入是否正确")
            }
            this.accountLogin();
        },
        async accountLogin() {
            try {
                const { data } = await this.wrapPromising(accountLogin({
                    upin:
                        this.currentStatus === "person"
                            ? this.personAccount
                            : this.account,
                    passwd:
                        this.currentStatus === "person"
                            ? sm2Encrypt(this.personPassWord)
                            : sm2Encrypt(this.passWord),
                    organid:
                        this.currentStatus === "person"
                            ? config.organid
                            : this.selectSchool,
                    source: "pc",
                    platformName: HOME_PAGE_MAP[this.$store.state.platform].domain
                }), "loading");
                if (data.code === -1) {
                    return this.$message({
                        type: "error",
                        message: `${data.msg}`
                    });
                }
                this.$store.commit("setUser", data.data);
                this.$message({
                    type: "success",
                    message: `登录成功`
                });
                await this.UserInfo();
                this.closeDiolog();
                // this.$router.replace("/")
            } catch (err) {
                return this.$message({
                    type: "error",
                    message: `登录失败`
                });
            }
        },
        // 管理员登录
        async manageLoginBtn() {
            try {
                if (!this.manageAccount) {
                    return this.$message({
                        type: "warning",
                        message: `请输入管理员账号`
                    });
                }
                if (!this.managePwd) {
                    return this.$message({
                        type: "warning",
                        message: `请输入密码`
                    });
                }

                const { data } = await this.wrapPromising(ManageLogin({
                    userAccount: this.manageAccount,
                    passWord: sm2Encrypt(this.managePwd),
                    platformName: HOME_PAGE_MAP[this.$store.state.platform].domain
                }), "loading");

                if (data.code === 100) {
                    this.$message({ type: "success", message: "登录成功！" });
                    this.$store.commit("setUser", data.data);
                    await this.adminInfo()
                } else {
                    this.$message({ type: "error", message: data.msg });
                }
            } catch (err) {
                this.$message({
                    type: "error",
                    message: `登录失败！`
                });
            }
        },
        async UserInfo() {
            try {
                const { data } = await UserInfo();
                this.$store.commit("setUserInfo", data.data);
                let val = JSON.stringify(data.data);
                this.$emit("changeLoginState", val);
                this.$bus.$emit("pc-login-success", data.data)
            } catch (err) {
                console.log(err);
                return this.$message({
                    type: "error",
                    message: `获取用户信息失败`
                });
            }
        },
        async adminInfo () {
            try {
                const res = await AdminUserInfo()
                if (res.data.code === 100) {
                    res.data.data.isManage = true;
                    this.$store.commit("setUserInfo", res.data.data);
                    this.closeDiolog();
                    this.$router.setManageRouteOfServer().then(() => {
                        this.$router.replace("/");
                    });
                } else {
                    this.$message.error("获取用户信息失败");
                }
            } catch (e) {

            }

        },
        gotoUserAgreement() {
            window.open(
                "http://yixue.cqvip.com/ragrent/img.html?time='javascript:Math.random()'"
            );
        },
        goToPrivacyAgreement() {
            window.open(
                "http://yixue.cqvip.com/ragrent/refet2.html?time='javascript:Math.random()'"
            );
        }
    }
};
</script>

<style scoped lang="less">
.loginCotain {
    .el-dialog__wrapper {
        display: flex;
        justify-content: center;
    }

    ::v-deep .el-input__icon {
        height: 85%;
    }

    ::v-deep .el-dialog {
        width: 82px;
        height: 550px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: unset;
        box-shadow: unset;

        .el-dialog__header {
            padding: 0;
        }
    }

    .Content {
        width: 820px;
        height: 550px;
        position: relative;
        padding: 50px;
        box-sizing: border-box;

        .icon {
            position: absolute;
            top: 0;
            right: 0;
        }

        .loginText {
            width: 720px;
            height: 490px;

            // background-color: pink;
            .images {
                width: 300px;
                height: 100%;
                background-color: red;
                background: url("../assets/img/loginBgc.png");
                background-size: 100% 100%;
                border-top-left-radius: 30px;
            }

            .form {
                width: 420px;
                height: 100%;
                background-color: white;
                border-bottom-right-radius: 70px;

                .navTit {
                    padding: 30px 80px 0px 80px;
                    box-sizing: border-box;
                    border-bottom: 1px solid #e5e8ec;
                    width: 100%;

                    .tab {
                        height: 35px;

                        .line {
                            width: 60px;
                            height: 3px;
                            background: #256cf4;
                        }
                    }

                    .perLogin {
                        margin-left: 20px;
                    }
                }

                .formMaps {
                    padding: 40px;
                    box-sizing: border-box;

                    .el-input {
                        height: 50px;
                        margin-bottom: 20px;
                    }

                    .personLofinPass {
                        margin-bottom: 0 !important;
                    }

                    ::v-deep .selectSchool {
                        width: 100%;
                    }

                    // .secondInputWord {
                    //     margin-top: 20px !important;
                    // }

                    .AgreementBox {
                        margin-top: 40px;
                    }
                }

                .schoolLogin {
                    .forgetPassWord {
                        margin-top: 10px;
                    }
                }

                .personLogin {
                    .AgreementBox {
                        margin-top: 110px;
                    }
                }

                .loginbtn {
                    width: 100%;
                    height: 45px;
                    background: #256cf4;
                    border-radius: 6px;
                    color: white;
                    font-size: 16px;
                    margin-top: 10px;
                }

                .registered {
                    width: 100%;
                    color: #f5434c;
                    font-size: 16px;
                    margin-top: 10px;
                    display: flex;
                    flex-direction: row-reverse;
                }
            }
        }

        .registerText {
            width: 720px;
            height: 590px;
            border-top-left-radius: 60px;
            border-bottom-right-radius: 60px;
            background-color: white;

            .titText {
                width: 100%;
                position: relative;
                border-bottom: 1px solid#E5E8EC;
                padding: 15px 65px;
                box-sizing: border-box;

                .back {
                    position: absolute;
                    left: 60px;
                }
            }

            .forms {
                width: 100%;

                .contain {
                    width: 60%;
                    list-style: none;
                    padding: 0;
                    margin: 0;
                    margin-right: 50px;

                    .containItem {
                        margin-bottom: 20px;

                        .rightInput {
                            width: 300px;

                            .yzmBtn {
                                width: 100px;
                                height: 38px;
                                background: #256cf4;
                                border-radius: 6px;
                                margin-left: 5px;
                                color: white;

                                .btn {
                                    width: 100%;
                                    height: 100%;
                                    background-color: pink;
                                }
                            }

                            .jsq {
                                width: 100px;
                                height: 38px;
                                border-radius: 6px;
                                margin-left: 5px;
                                color: white;
                                background-color: #bac0ca;
                            }
                        }

                        .label {
                            width: 120px;
                            display: flex;
                            justify-content: flex-end;
                            margin-right: 20px;
                        }

                        .regeterBtn {
                            background: #256cf4;
                            height: 48px;
                            border-radius: 6px;
                            color: white;
                            margin-top: 20px;
                        }
                    }

                    .containItem:nth-child(1) {
                        margin-top: 20px;
                    }
                }
            }
        }
    }

    .editorForm {
        .loginText {
            .form {
                .navTit {
                    padding-bottom: 10px;
                    box-sizing: border-box;
                    position: relative;

                    .backIcon {
                        position: absolute;
                        left: 20px;
                    }
                }

                .formMaps {
                    ::v-deep .el-input {
                        margin: 0;
                    }

                    .secondInputWord {
                        margin-top: 20px;
                        margin-bottom: 20px;
                    }

                    .yzmInput {
                        display: flex;
                        justify-content: space-between;
                        margin: 20px 0;

                        ::v-deep .el-input {
                            width: 65%;
                            box-sizing: border-box;
                        }

                        .yzmBtn {
                            height: 38px;
                            width: 100px;
                            background: #256cf4;
                            border-radius: 6px;
                            color: white;
                        }

                        .cutDown {
                            background: #bac0ca;
                            height: 38px;
                            width: 100px;
                            border-radius: 6px;
                            color: white;
                        }
                    }
                }
            }
        }
    }
}
</style>
